import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
    getCredit as onGetCredit,
    getTransactions as onGetTransactions,
    downloadTransactions as onDownloadTransactions
} from "services/dashboardApi";

export const getCredit = createAsyncThunk("dashboard/getCredit", async (_, { getState }) => {
    try {
      // Get the current state to check the partner's voucher model
      const state = getState() as any;
      const partner = state.Login.user.user.partner;
      
      // Only fetch credit if partner is not using voucher model
      if (!partner.voucherModel) {
        const response = await onGetCredit();
        return response;
      } else {
        // Return empty/default data when using voucher model
        return { credit: null };
      }
    } catch (error) {
        return error;
    }
});

export const getTransactions = createAsyncThunk("dashboard/getTransactions", async () => {
    try {
        const response = onGetTransactions();
        return response;
    } catch (error) {
        return error;
    }
});

export const downloadTransactions = createAsyncThunk(
  "dashboard/downloadTransactions", 
  async ({startDate, endDate}: {startDate?: string, endDate?: string} = {}) => {
    try {
        const response = onDownloadTransactions(startDate, endDate);
        return response;
    } catch (error) {
        return error;
    }
  }
);

